module.exports = __webpack_public_path__ + "img/IMG_9621_L_Wood.c456911e.jpg";